export const ADMIN_USER_ROLE = 'admin';
export const NURSE_USER_ROLE = 'nurse operator';
export const DOCTOR_USER_ROLE = 'consultation executioner';
